import { makeStyles, shorthands } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const usePdfDocumentPreviewStyles = makeStyles({
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: "600px",
    position: "relative",
  },
  rootNoScroll: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: "600px",
    position: "relative",
  },
  scrollContainer: {
    flex: 1,
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: designTokens.spacing[4],
    backgroundColor: projectIqTokens.bg2,
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
  },
  noScrollContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: designTokens.spacing[4],
    backgroundColor: projectIqTokens.bg2,
    ...shorthands.borderRadius(designTokens.borderRadius.lg),
  },
  pageWrapper: {
    marginBottom: designTokens.spacing[4],
    display: "flex",
    justifyContent: "center",
    width: "100%",
    backgroundColor: designTokens.neutral.white,
    ...shorthands.borderRadius(designTokens.borderRadius.md),
    boxShadow: projectIqTokens.shadowSm,
    padding: designTokens.spacing[2],

    "& canvas": {
      maxWidth: "100%",
      height: "auto",
    },
  },
  initialLoadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    minHeight: "600px",
  },
  documentLoadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: designTokens.spacing[4],
  },
  errorContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    gap: designTokens.spacing[3],
    minHeight: "600px",
    padding: designTokens.spacing[6],
    textAlign: "center",
    color: projectIqTokens.muted,
  },
  errorHeading: {
    fontSize: designTokens.fontSize.base,
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.ink,
  },
  errorBody: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink3,
    maxWidth: "400px",
  },
  loadingContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
    minHeight: "600px",
  },
});
